import axios from "axios";

// Pick a backend URL that avoids cross-origin CORS issues.
// - In the browser, if the configured backend origin matches the page origin
//   (e.g., the Emergent preview), use the env value as-is.
// - Otherwise (e.g., served from a custom domain like www.backyardbuddy.app
//   that Cloudflare/ingress proxies `/api/*` to the backend), call the
//   API on the SAME origin so the request is not cross-origin.
function resolveBackendUrl() {
  const envUrl = process.env.REACT_APP_BACKEND_URL || "";
  if (typeof window === "undefined") return envUrl;
  try {
    if (envUrl && new URL(envUrl).origin === window.location.origin) {
      return envUrl;
    }
  } catch (e) {
    // Invalid URL in REACT_APP_BACKEND_URL — surface for debugging, then fall
    // through to same-origin (which always works on the deployed domain).
    console.warn("Invalid REACT_APP_BACKEND_URL, falling back to same-origin:", e?.message);
  }
  return window.location.origin;
}

const BACKEND_URL = resolveBackendUrl();
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export default api;

export function formatErr(e) {
  const detail = e?.response?.data?.detail;
  if (!detail) return e?.message || "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => d.msg || JSON.stringify(d)).join(" ");
  return JSON.stringify(detail);
}
